import {
  createEntryPreviewStore,
  readTappedThumbnail,
} from '@/app/_components/entryPreview';

export interface GiftPreview {
  productNumber: string;
  mainImageUrl?: string;
  thumbnailSrc?: string;
  productName?: string;
  institutionName?: string;
  donationAmount?: number;
}

export { readTappedThumbnail };

const toProductNumber = (slug: string) => slug.split('--').pop() ?? slug;

const giftPreviewStore = createEntryPreviewStore<GiftPreview>();

export const rememberGiftPreview = giftPreviewStore.remember;
export const clearGiftPreview = giftPreviewStore.clear;
export const subscribeGiftPreview = giftPreviewStore.subscribe;
export const getGiftPreviewSnapshot = giftPreviewStore.getSnapshot;

export const matchGiftPreview = (
  preview: GiftPreview | null,
  slug?: string,
) => {
  if (!preview || !slug) {
    return null;
  }

  return toProductNumber(preview.productNumber) === toProductNumber(slug)
    ? preview
    : null;
};
